import React from "react";
import "./FinancialTable.scss";

const fmt = (val) =>
  Number(val ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function buildSections(cy, py) {
  return [
    {
      title: "PASURITE",
      items: [
        { id: "1000", code: "1000", label: "Paraja dhe ekuivalentet e parasë", note: "1", currentVal: cy.paraja, priorVal: py.paraja },
        { id: "1050", code: "1050", label: "Investimet financiare afatshkurtera", note: "2", currentVal: cy.investimetFinanciareAfatshkurtera, priorVal: py.investimetFinanciareAfatshkurtera },
        { id: "1100", code: "1100", label: "Llogaritë e arkëtueshme tregtare dhe të tjera", note: "3", currentVal: cy.llogariteArketueshme, priorVal: py.llogariteArketueshme },
        { id: "1150", code: "1150", label: "Stoqet", note: "4", currentVal: cy.stoqet, priorVal: py.stoqet },
        { id: "1200", code: "1200", label: "Pasuritë tjera afatshkurtera", note: "5", currentVal: cy.pasuriteTjeraAfatshkurtera, priorVal: py.pasuriteTjeraAfatshkurtera },
        { id: "A", code: "", label: "Gjithsej pasuritë afatshkurtera [A]", currentVal: cy.gjithsejPasuritAfatshkurtera, priorVal: py.gjithsejPasuritAfatshkurtera, isTotal: true },
        { id: "1300", code: "1300", label: "Investimet në pjesëmarrje", note: "6", currentVal: cy.investimetPjesmarrje, priorVal: py.investimetPjesmarrje },
        { id: "1350", code: "1350", label: "Investimet në filial", note: "7", currentVal: cy.investimetFiliale, priorVal: py.investimetFiliale },
        { id: "1400", code: "1400", label: "Investimet financiare afatgjata", note: "8", currentVal: cy.investimetFinanciareAfatgjata, priorVal: py.investimetFinanciareAfatgjata },
        { id: "1450", code: "1450", label: "Prona, paisjet dhe impiantet", note: "9", currentVal: cy.pronaPaisjetImpiantet, priorVal: py.pronaPaisjetImpiantet },
        { id: "1500", code: "1500", label: "Pronat investuese", note: "10", currentVal: cy.pronaInvestuese, priorVal: py.pronaInvestuese },
        { id: "1550", code: "1550", label: "Investimet në vijim", note: "11", currentVal: cy.investimetNeVijim, priorVal: py.investimetNeVijim },
        { id: "1600", code: "1600", label: "Pasuritë e paprekshme", note: "12", currentVal: cy.pasuritePaprekshme, priorVal: py.pasuritePaprekshme },
        { id: "1650", code: "1650", label: "Pasuritë e shtyra tatimore", note: "13", currentVal: cy.pasuriteShtyraTatimore, priorVal: py.pasuriteShtyraTatimore },
        { id: "1700", code: "1700", label: "Pasuritë tjera afatgjata", note: "14", currentVal: cy.pasuriteTjeraAfatgjata, priorVal: py.pasuriteTjeraAfatgjata },
        { id: "B", code: "", label: "Gjithsej pasuritë afatgjata [B]", currentVal: cy.gjithsejPasuritAfatgjata, priorVal: py.gjithsejPasuritAfatgjata, isTotal: true },
        { id: "C", code: "", label: "Gjithsej pasuritë [C=A+B]", currentVal: cy.gjithsejPasurit, priorVal: py.gjithsejPasurit, isTotal: true },
      ],
    },
    {
      title: "DETYRIMET DHE EKUITETI",
      items: [
        { id: "2000", code: "2000", label: "Mbitërheqja bankare", note: "15", currentVal: cy.mbiterheqjaBankare, priorVal: py.mbiterheqjaBankare },
        { id: "2050", code: "2050", label: "Llogaritë e pagueshme tregtare dhe të tjera", note: "16", currentVal: cy.llogaritePagueshmeTjera, priorVal: py.llogaritePagueshmeTjera },
        { id: "2100", code: "2100", label: "Kreditë/Huatë afatshkurtera", note: "17", currentVal: cy.krediteHuateAfatshkurter, priorVal: py.krediteHuateAfatshkurter },
        { id: "2150", code: "2150", label: "Interesi i pagueshëm", note: "18", currentVal: cy.interesiPagueshme, priorVal: py.interesiPagueshme },
        { id: "2200", code: "2200", label: "Tatimi në fitim i pagueshëm", note: "19", currentVal: cy.tatimiFitimPagueshem, priorVal: py.tatimiFitimPagueshem },
        { id: "2250", code: "2250", label: "Provizionet afatshkurta", note: "20", currentVal: cy.provizionetAfatshkurta, priorVal: py.provizionetAfatshkurta },
        { id: "2300", code: "2300", label: "Detyrimet e lizingut afatshkurter", note: "21", currentVal: cy.detyrimetLizingutAfatshkurter, priorVal: py.detyrimetLizingutAfatshkurter },
        { id: "2350", code: "2350", label: "Detyrime tjera afatshkurtera", note: "22", currentVal: cy.detyrimetTjeraAfatshkurtera, priorVal: py.detyrimetTjeraAfatshkurtera },
        { id: "D", code: "", label: "Gjithsej detyrimet afatshkurtera [D]", currentVal: cy.gjithsejDetyrimetAfatshkurtera, priorVal: py.gjithsejDetyrimetAfatshkurtera, isTotal: true },
        { id: "2400", code: "2400", label: "Kreditë/Huatë afatgjata", note: "23", currentVal: cy.krediteHuateAfatgjata, priorVal: py.krediteHuateAfatgjata },
        { id: "2450", code: "2450", label: "Provizionet afatgjata", note: "24", currentVal: cy.provizionetAfatgjata, priorVal: py.provizionetAfatgjata },
        { id: "2500", code: "2500", label: "Detyrimet e lizingut afatgjatë", note: "25", currentVal: cy.detyrimetLizingutAfatgjate, priorVal: py.detyrimetLizingutAfatgjate },
        { id: "2550", code: "2550", label: "Detyrimet e shtyra tatimore", note: "26", currentVal: cy.detyrimetShtyraTatimore, priorVal: py.detyrimetShtyraTatimore },
        { id: "2600", code: "2600", label: "Detyrime tjera afatgjata", note: "27", currentVal: cy.detyrimetTjeraAfatgjata, priorVal: py.detyrimetTjeraAfatgjata },
        { id: "E", code: "", label: "Gjithsej detyrimet afatgjata [E]", currentVal: cy.gjithsejDetyrimetAfatgjata, priorVal: py.gjithsejDetyrimetAfatgjata, isTotal: true },
        { id: "DE", code: "", label: "Gjithsej detyrimet [D+E]", currentVal: cy.gjithsejDetyrimet, priorVal: py.gjithsejDetyrimet, isTotal: true },
        { id: "3000", code: "3000", label: "Kapitali i pronarit", note: "28", currentVal: cy.kapitaliPronarit, priorVal: py.kapitaliPronarit },
        { id: "3100", code: "3100", label: "Fitimi i bartur", note: "29", currentVal: cy.fitimiBartur, priorVal: py.fitimiBartur },
        { id: "3200", code: "3200", label: "Rezervat e tjera", note: "30", currentVal: cy.rezervatTjera, priorVal: py.rezervatTjera },
        { id: "F", code: "", label: "Gjithsej ekuiteti [F]", currentVal: cy.gjithsejEkuiteti, priorVal: py.gjithsejEkuiteti, isTotal: true },
        { id: "G", code: "", label: "Totali i ekuitetit dhe detyrimeve [G=D+E+F]", currentVal: cy.totaliEkuitetiDetyrimet, priorVal: py.totaliEkuitetiDetyrimet, isTotal: true },
      ],
    },
  ];
}

function LoadingRows() {
  return (
    <div className="FS__Table__Loading">
      {[1, 2, 3].map((item) => (
        <div key={item} className="FS__Table__LoadingCard" />
      ))}
    </div>
  );
}

export default function FinancialTable({ currentYear, priorYear, fiscalYear, loading }) {
  if (loading) {
    return <LoadingRows />;
  }

  const cy = currentYear ?? {};
  const py = priorYear ?? {};
  const priorFiscalYear = Number(fiscalYear) - 1;
  const sections = buildSections(cy, py);

  return (
    <div className="FS__Table__Card">
      <div className="FS__Table__DesktopHeader">
        <div className="FS__Table__DesktopHeaderDescription">Përshkrimi</div>
        <div className="FS__Table__DesktopHeaderNote">Shënimi</div>
        <div className="FS__Table__DesktopHeaderAmount">Më 31.12.{fiscalYear}</div>
        <div className="FS__Table__DesktopHeaderAmount">Më 31.12.{priorFiscalYear}</div>
      </div>

      <div className="FS__Table__Sections">
        {sections.map((section) => (
          <div key={section.title} className="FS__Table__Section">
            <div className="FS__Table__SectionHeader">
              <h3>{section.title}</h3>
            </div>

            <div className="FS__Table__Rows">
              {section.items.map((item) => (
                <div
                  key={item.id}
                  className={[
                    "FS__Table__Row",
                    item.isTotal ? "FS__Table__Row--total" : "FS__Table__Row--default",
                  ].join(" ")}
                >
                  <div className="FS__Table__DescriptionWrap">
                    <div className="FS__Table__Code">{item.code}</div>
                    <div className="FS__Table__LabelWrap">
                      <span className="FS__Table__Label">{item.label}</span>
                      {item.note ? <span className="FS__Table__MobileNote">Shënimi {item.note}</span> : null}
                    </div>
                  </div>

                  <div className="FS__Table__NoteCell">
                    {item.note ? <span className="FS__Table__NoteValue">{item.note}</span> : null}
                  </div>

                  <div className="FS__Table__AmountCell">
                    <span className="FS__Table__AmountLabel">Aktual</span>
                    <span className="FS__Table__AmountValue">{fmt(item.currentVal)}</span>
                  </div>

                  <div className="FS__Table__AmountCell FS__Table__AmountCell--prior">
                    <span className="FS__Table__AmountLabel">Paraprak</span>
                    <span className="FS__Table__AmountValue">{fmt(item.priorVal)}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
